import { Link } from "@chakra-ui/next-js";
import {
  AspectRatio,
  Box,
  Button,
  Flex,
  FlexProps,
  Heading,
  Image,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { ListingPreview } from "~/lib/listingPreview";
import { mediaUrl } from "~/lib/media";
import { IconX } from "@tabler/icons-react";
import { Pin } from "~/images/svgs";

type ListingInfoWindowProps = {
  listing?: ListingPreview;
  onClose: () => void;
};
export const ListingInfoWindow = ({
  listing,
  onClose,
}: ListingInfoWindowProps) => {
  const position = useBreakpointValue<FlexProps>(
    {
      base: {
        left: "50%",
        top: "50%",
        transform: "translateX(-50%) translateY(-50%)",
      },
      md: { top: 20, right: 8 },
    },
    { ssr: false }
  );
  if (!listing) return null;
  const image = mediaUrl(listing.lead_media);
  return (
    <Flex
      direction="column"
      position="absolute"
      {...position}
      gap={4}
      align="flex-start"
      width={{ base: "70vw", md: "50vw", lg: "262px" }}
      zIndex={1}
      bgColor={"white"}
      p={4}
      borderRadius={"md"}
    >
      <Box
        cursor="pointer"
        onClick={onClose}
        pos="absolute"
        top={4}
        right={4}
        color="gray.900"
        borderRadius="full"
        borderColor="gray.900"
        borderWidth={2}
        bgColor="white"
        zIndex={2}
      >
        <IconX />
      </Box>

      <AspectRatio ratio={1} w="100%">
        <Image
          borderRadius={"md"}
          src={image || "/StopFillerImage.jpg"}
          alt="Stop Image"
        />
      </AspectRatio>

      <Box
        display="flex"
        flexDirection="column"
        w={{ base: "100%", md: "auto" }}
        h={{ base: "100%" }}
        justifyContent="space-between"
        gap={1}
      >
        <Heading fontSize={{ base: "md" }} fontWeight="normal">
          {listing.name}
        </Heading>
        <Text fontSize={{ base: "sm" }} fontStyle="italic" fontWeight="thin">
          <Pin boxSize={"12px"} /> {listing.city}
        </Text>
        {listing.short_description && (
          <Text
            noOfLines={{ base: 3 }}
            fontWeight="thin"
            fontSize={{ base: "sm" }}
          >
            {listing.short_description}
          </Text>
        )}
      </Box>
      {listing.website && (
        <Button size="sm" as={Link} href={listing.website} target="_blank">
          Learn More
        </Button>
      )}
    </Flex>
  );
};
